<template>
  <div>
    <span v-if="status == 'Ativo'" class="size-status" style="color: #53db60">
      <v-icon small color="#53db60" class="icon-status pb-1">mdi-database-check-outline</v-icon>
      Ativo
    </span>
    <span v-else class="size-status" style="color: gray">
      <v-icon small color="gray" class="icon-status pb-1">mdi-database-off-outline</v-icon>
      Inativo
    </span>
  </div>
</template>

<script>
  export default {
    props: {
      status: {
        type: String,
        required: true
      }
    }
  };
</script>

<style>
  .size-status {
    font-size: 0.95rem !important;
    font-weight: normal !important;
  }

  .size-status .v-icon {
    font-size: 0.9rem !important;
  }

  .icon-status {
    margin-right: 1.7px !important;
  }
</style>
